import type { CustomFlowbiteTheme } from 'flowbite-react';

export const selectTheme: CustomFlowbiteTheme['select'] = {
  base: 'flex',
  addon:
    'border-titan-night-300 bg-titan-night-200 text-titan-night-900 inline-flex items-center rounded-l-md border border-r-0 px-3 text-sm',
  field: {
    base: 'relative w-full',
    icon: {
      base: 'pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3',
      svg: 'text-titan-night-500 h-5 w-5',
    },
    select: {
      base: 'block w-full border disabled:cursor-not-allowed disabled:opacity-50',
      withIcon: {
        on: 'pl-10',
        off: '',
      },
      withAddon: {
        on: 'rounded-r-lg',
        off: '',
      },
      withShadow: {
        on: 'shadow-sm',
        off: '',
      },
      sizes: {
        sm: 'p-2 sm:text-xs',
        md: 'p-2.5 text-sm',
        lg: 'p-4 sm:text-base',
      },
      colors: {
        white:
          'border-titan-night-300 text-titan-night-900 focus:border-titan-night-500 focus:ring-titan-night bg-white',
        gray: 'border-titan-night-300 text-titan-night-900',
        info: 'border-titan-folly-500 bg-titan-folly-50 text-titan-folly-900 placeholder-titan-folly-700',
        failure:
          'border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500',
        warning:
          'border-titan-yellow-500 bg-titan-yellow-50 text-titan-yellow-900 placeholder-titan-yellow-700 focus:border-titan-yellow-500 focus:ring-titan-yellow-500',
        success:
          'border-green-500 bg-green-50 text-green-900 placeholder-green-700 focus:border-green-500 focus:ring-green-500',
      },
    },
  },
};
